import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Icon from '../../icon'
import Typography from '../../typography'

import Users from '../../icon/users.svg'
import Star from '../../icon/star.svg'

const Stats = ({ course, ...attrs }) => {
  const subscriptions = get(course, 'subscriptions', 0)
  const likes = get(course, 'likes', 0)

  attrs.className = classNames(
    attrs.className,
    [
      'flex',
      'flex-row',
      'items-center'
    ]
  )
  return <div
    {...attrs}>
    <div
      className={
        classNames([
          'flex',
          'flex-row',
          'justify-center',
          'items-center',
          'mr-10'
        ])
      }>
      <Icon
        className={'mr-2 text-yellow-500'}
        svg={Star}
        width={24}
        height={24} />
      <Typography
        size={'three'}
        weight={'regular'}>
        {likes}
      </Typography>
    </div>
    <div
      className={
        classNames([
          'flex',
          'flex-row',
          'justify-center',
          'items-center'
        ])
      }>
      <Icon
        className={'mr-2 text-turquoise-500'}
        svg={Users}
        width={24}
        height={24} />
      <Typography
        size={'three'}
        weight={'regular'}>
        {subscriptions}
      </Typography>
    </div>
  </div>
}

Stats.propTypes = {
  course: PropTypes.object
}

export default Stats
